import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import english from 'locales/en.json';
import french from 'locales/fr.json';

const resources = {
  en: {
    translation: { ...english },
  },
  fr: {
    translation: { ...french },
  },
};

const DETECTION_OPTIONS = {
  order: ['navigator'],
};

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: DETECTION_OPTIONS,
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export const t = (str: string, options = {}) => i18next.t(str, { ...options });

export default i18next;
